import { render, staticRenderFns } from "./Received.vue?vue&type=template&id=5176ba0c&"
import script from "./Received.vue?vue&type=script&lang=js&"
export * from "./Received.vue?vue&type=script&lang=js&"
import style0 from "./Received.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports